<template>
  <div class="white-container full-page-container common-table">
    <div class="coach-preorder operation-bar">
      <div class="coupon_tip import">导入教练券</div>
      <el-upload
        ref="uploader"
        class="uploader"
        action=""
        :show-file-list="false"
        :on-change="importCoupons"
        :auto-upload="false"
      >
        <el-button size="small" type="primary">上传文件</el-button>
      </el-upload>
      <div class="coupon_tip upload_tips">仅支持上传*.xls、*.xlsx格式</div>
      <a
        download
        class="download-file"
        href="https://uadev-1257321318.file.myqcloud.com/static/excel/coachVocherTemplate847534f085e2328f10dc84203ef277ff.xlsx"
      >
        <i class="el-icon-document" />下载文件模板
      </a>
    </div>
    <div class="common-text" style="margin: 20px auto">历史导入记录</div>
    <TableList
      ref="multipleTable"
      size="small"
      :table-query="search"
      :query-function="$Api.coach.getCardVoucher"
      style="width: 100%"
    >
      <el-table-column prop="id" label="ID" fixed />
      <el-table-column prop="name" label="文件名">
        <template slot-scope="scope">
          <a :href="scope.row.url" download class="download-file">{{
            scope.row.name
          }}</a>
        </template>
      </el-table-column>
      <el-table-column prop="uploader" label="上传者" />
      <el-table-column prop="uploadTime" label="上传时间" />
    </TableList>
  </div>
</template>
<script>
import TableList from "@/components/TableList/index.vue";
import { getFileType } from "@/common/js/util";

export default {
  components: { TableList },
  data() {
    return {
      search: {},
      form: {
        file: "",
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    importCoupons(file) {
      if (getFileType(file.raw.name) !== "excel") {
        this.$message.error("导入失败，请选择Excel文件");
        this.$refs.uploader.clearFiles();
        return;
      }
      const excelName = file.raw.name;
      this.$Api.uploadFile.uploadExcel(file.raw, "ua_activity/detail/")
        .then(data => {
          const formData = new FormData();
          formData.append("excelName", excelName);
          formData.append("url", data);
          formData.append("multipartFile", file.raw);
          this.$Api.coach.postImportCode(formData).then(data => {
            this.$message.success("上传成功");
            this.$refs["multipleTable"].searchAndReset();
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.coach-preorder {
  display: flex;
  align-items: center;
  .coupon_tip {
    font-size: 14px;
    color: #494949;
    margin-right: 10px;
  }
  .upload_tips {
    color: #9b9b9b;
    width: 250px;
    margin-left: 10px;
  }
  .download-file {
    font-family: "Noto Sans SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #0085d0 !important;
    cursor: pointer;
    text-decoration: none !important;
    .el-icon-document {
      margin-right: 7px;
    }
  }
}
</style>
